<template>
  <div class="kbli-container">
    <div class="modal-company-kbli-wrapper">
      <div class="column100 flex-row">
        <div class="text-bold column10">No</div>
        <div class="text-bold column90">Jenis Usaha</div>
      </div>
      <div
        class="column100 flex-row mt10"
        v-if="inubbmVendor.length > 0"
        v-for="(list, index) in inubbmVendor"
        :key="index"
      >
        <div class="column10">{{ index + 1 }}</div>
        <div class="column90">{{ list.master_inu_bbm.desc }}</div>
      </div>
    </div>

    <div class="kbli-mobile-container for-mobile">
      <div
        class="kbli-mobile-list"
        v-if="inubbmVendor.length > 0"
        v-for="(list, index) in inubbmVendor"
        :key="index"
      >
        <div class="w-full text-gray">Jenis Usaha</div>
        <div class="w-full">{{ list.master_inu_bbm.desc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    inubbmVendor() {
      return this.$store.state.level1.inubbmVendor
    },
  },
  created() {},
  methods: {},
}
</script>
